import { RejectionReasonsCodeType } from '@percent/admin-dashboard/api/types'

export const mapRejectionReasonCode: Record<RejectionReasonsCodeType, string> = {
  not_eligible: 'dropdown.rejectionReason.notEligible',
  incorrect_documentation: 'dropdown.rejectionReason.incorrectDocumentation',
  not_attributable_to_registry: 'dropdown.rejectionReason.notAttributableToRegistry',
  suspicious_application: 'dropdown.rejectionReason.suspiciousApplication',
  other: 'dropdown.rejectionReason.other'
}
